// @flow
import React from 'react'

type TextIconProps = {
  className: string,
  svg: string,
  text: string,
}

const TextIcon = (props: TextIconProps) => {
  return (
    <div className={props.className}>
      <img alt={props.text} src={props.svg} />
      <div className="w-100">
        <span className="name">{props.text}</span>
      </div>
    </div>
  )
}

export default TextIcon
